// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__31Y9Z","tab":"Tabs_tab__2LEoc","tabActive":"Tabs_tabActive__2s9C5"};